import { Navigate, useParams } from 'react-router-dom';
import { categoryBrowsePath } from '../categoryPaths';

/** Legacy /browse/:slug → /shop/:slug */
export function BrowseRedirect() {
  const { slug } = useParams();
  return <Navigate to={categoryBrowsePath(slug ?? '')} replace />;
}
